import { render, staticRenderFns } from "./table-detail.vue?vue&type=template&id=7e87931c&scoped=true&"
import script from "./table-detail.vue?vue&type=script&lang=js&"
export * from "./table-detail.vue?vue&type=script&lang=js&"
import style0 from "./table-detail.vue?vue&type=style&index=0&id=7e87931c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e87931c",
  null
  
)

export default component.exports